"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#MuleAppAsset',
    assetType: 'MuleApp'
  },
  owner: {
    gusTeam: 'MS Runtime Manager',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00B000000CuUtgIAF/view'
  },
  name: 'Application',
  publication: {
    inferredBy: [{
      classifiers: ['mule-application']
    }, {
      typeProperty: 'app'
    }],
    files: [{
      id: 'mule4',
      classifier: 'mule-application',
      packaging: 'jar'
    }, {
      id: 'mule3',
      classifier: null,
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: ['mule4']
    }, {
      files: ['mule3']
    }],
    ootbSteps: [{
      name: 'angModelExtraction'
    }],
    extensionPoints: [{
      name: 'legacyMetadataExtraction'
    }]
  },
  keywords: ['application', 'app']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map